export default __webpack_public_path__ + "static/media/highway.f367220d.png";